<template>
	<md-card-content>
		<div id="notes">
			<md-field class="md-invalid">
				<label>Note</label>
				<md-textarea v-model="client.notes" name="note" md-autogrow disabled></md-textarea>
			</md-field>
			<md-button class="md-warning w-full mb-0 mt-2"
				@click="goToRoute('Client Notes Edit', client.id)">
				Modifier les notes
			</md-button>
		</div>
		<div class="separator mt-3"></div>
		<div id="personal-message" class="mt-3">
			<h2>Message personnel</h2>
			<p class="my-2">Formulaire pour mettre à jour le message personnel du client qui apparaitra dans son espace client.</p>
			<md-button class="md-warning w-full mb-0"
				@click="goToRoute('Client Message Edit', client.id)">
				Modifier le message personnel
			</md-button>
		</div>
	</md-card-content>
</template>

<script>
export default {
	name: "Notes",
	props: {
		client: Object
	},
	methods: {
		goToRoute(route, id = null) {
			this.$router.push({ name: route, params: { id } })
		}
	}
}
</script>

<style scoped lang="scss">
#notes {
	::v-deep {
		.md-field {
			.md-textarea {
				max-height: 225px;
				height: 100%;
			}
		}
	}
}

#personal-message {
	h2 {
		font-size: 1rem;
		font-weight: 400;
	}

	p {
		line-height: 1.25;
	}
}

.separator {
	width: 100%;
	height: 1px;
	background: #ddd;
}
</style>
